import { LocationStrategy, PathLocationStrategy, registerLocaleData } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import localePlExtra from '@angular/common/locales/extra/pl';
import localeUkExtra from '@angular/common/locales/extra/uk';
import localePl from '@angular/common/locales/pl';
import localeUk from '@angular/common/locales/uk';
import { NgModule, inject } from '@angular/core';
import { AccountModule } from './account/account.module';
import { RedirectToLoginOrRegisterDialog } from './account/redirect-to-login-or-register-dialog/redirect-to-login-or-register-dialog';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthCallbackComponent } from './auth-callback/auth-callback.component';
import { ConsentService } from './data/consent.service';
import { LanguageService } from './data/language.service';
import { WorkerService } from './data/worker.service';
import { FooterComponent } from './footer/footer.component';
import { ErrorHandlingInterceptor } from './interceptors/error-handling.interceptor';
import { SelectLanguageComponent } from './shared/components/select-language/select-language.component';
import { SharedModule } from './shared/shared.module';
import { WorkerAgreementsRoutingModule } from './worker-agreements/worker-agreements-routing.module';
import { WorkerAgreementsModule } from './worker-agreements/worker-agreements.module';
import { WorkersRoutingModule } from './workers/workers-routing.module';
import { WorkersModule } from './workers/workers.module';
import { IndexComponent } from './index/index/index.component';
import { IndexTopbarComponent } from './index/index-topbar/index-topbar.component';
import { IndexFooterComponent } from './index/index-footer/index-footer.component';
import { AbsencesModule } from './absences/absences.module';
import { AbsencesRoutingModule } from './absences/absences-routing.module';
import { FamilyMembersModule } from './family-members/family-members.module';
import { EmploymentHistoryModule } from './employment-history/employment-history.module';
import { AgreementOfEmploymentModule } from './agreement-of-employment/agreement-of-employment.module';
import { AgreementOfEmploymentRoutingModule } from './agreement-of-employment/agreement-of-employment-routing.module';
import { WageAllowanceModule } from './wage-allowance/wage-allowance.module';
import { InternalWorkersModule } from './internal-workers/internal-workers.module';
import { InternalWorkersRoutingModule } from './internal-workers/internal-workers-routing.module';
import { IndexFunctionalityComponent } from './index/index-functionality/index-functionality.component';
import { DelegationsRoutingModule } from './delegations/delegations-routing.module';
import { ReportsRoutingModule } from './reports/reports-routing.module';
import { PresencesRoutingModule } from './presence/presences-routing.module';
import { PresencesModule } from './presence/presences.module';
import { LegalizationsRoutingModule } from './legalizations/legalizations-routing.module';
import { LegaliaztionsModule } from './legalizations/legalizations.module';
import { TalentinaComponent } from './talentina/talentina/talentina.component';
import { TalentinaService } from './data/talentina.service';
import { TalentinaAccessGuard } from './talentina/talentina-access.guard';
import { DeclarationsModule } from './declarations/declarations.module';
import { DeclarationsRoutingModule } from './declarations/declarations-routing.module';
import { DictionaryService } from './data/dictionary.service';
import { DuplicateCallInterceptor } from './interceptors/duplicate-call.interceptor';
import { AuthConfigModule } from './auth/auth-config.module';
import { AbstractSecurityStorage, AuthInterceptor, EventTypes, PublicEventsService } from 'angular-auth-oidc-client';
import { filter } from 'rxjs';
import { LocalStorageService } from './auth/local-storage.service';
import { IndexCaseStudyThaiWokComponent } from './index/index-case-study-thai-wok/index-case-study-thai-wok.component';
import { IndexCaseStudyComponent } from './index/index-case-study/index-case-study.component';
import { ReportsModule } from './reports/reports.module';
import { SignInInitComponent } from './sign-in-init/sign-in-init.component';
import { RegulationsAndProceduresComponent } from './regulations-and-procedures/regulations-and-procedures.component';
import { QrCodeComponent } from './qr-codes/qr-code.component';
import { QRCodeComponent } from 'angularx-qrcode';
import { LogWorkComponent } from './log-work/log-work/log-work.component';
import { QrCodeService } from './data/qr-code.service';
import { StatisticsModule } from './statistics/statistics.module';
import { StatisticsRoutingModule } from './statistics/statistics-routing.module';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';
import { environment } from '../environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { HolidaysModule } from './holidays/holidays.module';
import { HolidaysRoutingModule } from './holidays/holidays-routing.module';
import { OrdersRoutingModule } from './orders/orders-routing.module';
import { OrdersModule } from './orders/orders.module';
import { DateInterceptor } from './interceptors/date.interceptor';
import { WorkerFileVerificationModule } from './worker-file-verification/worker-file-verification.module';
import { AdminModule } from './admin/admin.module';
import { AdminRoutingModule } from './admin/admin-routing.module';

registerLocaleData(localePl, 'pl', localePlExtra);
registerLocaleData(localeUk, 'uk', localeUkExtra);

// WARNING: order of imported routing modules is very important!
@NgModule({
  declarations: [
    AppComponent,
    AuthCallbackComponent,
    RedirectToLoginOrRegisterDialog,
    SelectLanguageComponent,
    FooterComponent,
    IndexComponent,
    IndexTopbarComponent,
    IndexFooterComponent,
    IndexFunctionalityComponent,
    TalentinaComponent,
    IndexCaseStudyThaiWokComponent,
    IndexCaseStudyComponent,
    SignInInitComponent,
    RegulationsAndProceduresComponent,
    QrCodeComponent,
    LogWorkComponent,
  ],
  imports: [
    SharedModule,
    AccountModule,
    FamilyMembersModule,
    EmploymentHistoryModule,
    InternalWorkersModule,
    InternalWorkersRoutingModule,
    AbsencesModule,
    AbsencesRoutingModule,
    PresencesModule,
    PresencesRoutingModule,
    HolidaysModule,
    HolidaysRoutingModule,
    WorkerAgreementsModule,
    WorkerAgreementsRoutingModule,
    AgreementOfEmploymentModule,
    AgreementOfEmploymentRoutingModule,
    WorkersModule,
    QRCodeComponent,
    WorkersRoutingModule,
    DelegationsRoutingModule,
    ReportsRoutingModule,
    ReportsModule,
    LegalizationsRoutingModule,
    LegaliaztionsModule,
    WageAllowanceModule,
    DeclarationsModule,
    DeclarationsRoutingModule,
    StatisticsRoutingModule,
    StatisticsModule,
    OrdersRoutingModule,
    OrdersModule,
    WorkerFileVerificationModule,
    AdminModule,
    AdminRoutingModule,
    AppRoutingModule,
    AuthConfigModule,
    ServiceWorkerModule.register('ngsw-worker.js', {
      enabled: environment.serviceWorker
    })
  ],
  providers: [
    LanguageService,
    WorkerService,
    ConsentService,
    DictionaryService,
    TalentinaService,
    TalentinaAccessGuard,
    QrCodeService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorHandlingInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DuplicateCallInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: DateInterceptor, multi: true },
    { provide: LocationStrategy, useClass: PathLocationStrategy },
    { provide: AbstractSecurityStorage, useClass: LocalStorageService },
    provideCharts(withDefaultRegisterables())
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  private eventService = inject(PublicEventsService);

  constructor() {
    this.eventService
      .registerForEvents()
      .pipe(
        filter((notification) => notification.type === EventTypes.ConfigLoaded)
      )
      .subscribe((config) => console.log('ConfigLoaded', config));
  }
}
